import React, {useContext, useMemo} from 'react'
import classNames from 'classnames'
import {CodiSiderHeading} from './CodiSiderHeading'
import CodiDocumentContext from '../../CodiDocumentContext'
import _ from 'lodash'
import {Link} from 'react-router-dom'
import useTranslate from '../../../../modules/local/useTranslate'
import {FaHashtag} from 'react-icons/fa6'
import {ToggleCollapseView} from '../../../../components/Toggle/ToggleCollapseView'
import getLinkToDetail from '../../../../helpers/getLinkToDetail'
import {keyword_getKeywordsByDocumentId_Api} from '../../../../apis'
import EntityList from '../../../AppLocals/EntityList'
import {bindQueryParams} from '../../../AppLocals/functions/routerHelper'
import TooltipApp from "components/TooltipApp";

const CodiDocumentKeyWord = ({style, className, Wrapper = 'div'}) => {
  const t = useTranslate()
  const {item} = useContext(CodiDocumentContext)
  const keywords = _.get(item, 'keywords', _.get(item, 'document.keywords', []))

  const apiInfo = keyword_getKeywordsByDocumentId_Api

  const refreshKey = useMemo(
    () => [apiInfo?.path?.replace(':document_id', item?.document?.id)].join('/'),
    [item]
  )

  const KeywordTitle = ({title, total = 0}) => {
    const displayKeyword = () => {
      const str = _.isEmpty(total) ? '' : ` (${total})`
      return `${title}${str}`
    }

    return <span>{displayKeyword(title, total)}</span>
  }

  const KeywordItem = ({item}) => {
    const {description} = item

    const document = _.get(item, 'owner')

    return (
      <div className="flex flex-col ml-1">
        {!_.isEmpty(document) && (
          <TooltipApp title={document.title}>
            <Link
              target="_blank"
              to={getLinkToDetail(document)}
              className="font-bold text-xs text-color-100 max-lines-2 no-underline">
              {document.title}
            </Link>
          </TooltipApp>
        )}
        <div className="flex flex-1 items-center gap-1 mt-1 text-color-400 italic text-xs max-lines-3">
          {description}
        </div>
      </div>
    )
  }

  return (
    <Wrapper
      style={style}
      className={classNames('flex flex-col', className)}>
      <CodiSiderHeading
        title="keyword"
        icon={
          <FaHashtag
            size={20}
            style={{marginTop: '0.15rem'}}
            className="text-primary"
          />
        }
      />
      <EntityList
        key={refreshKey}
        apiInfo={apiInfo}
        refreshKey={refreshKey}
        query={bindQueryParams([{document_id: item?.document?.id}])}
        renderItem={(e) => (
          <ToggleCollapseView
            defaultValue={false}
            style={{paddingBottom: '3px'}}
            title={
              <KeywordTitle
                title={e.keyword}
                total={keywords.length}
              />
            }>
            {_.get(e, 'keyword_refs').map((ref) => (
              <KeywordItem
                key={ref.id}
                item={ref}></KeywordItem>
            ))}
          </ToggleCollapseView>
        )}
        RenderEntity={React.Fragment}
      />
    </Wrapper>
  )
}

export default CodiDocumentKeyWord
